<template>
    <div class="widget knowledge-base-widget">
        <header class="widget-header">
            <h3><i class="fal fa-life-ring purple" /> Knowledge Base</h3>
        </header>

        <div class="widget-body">
            <div ref="articlesWrap" class="articles">
                <div class="article">
                    <h4>
                        <a href="#" @click.prevent="toggleArticle">What platforms does Fusebox 2.0 support?</a>
                    </h4>
                    <div class="expandable">
                        <div class="article-content">
                            <p>
                                No two websites builders are the same. So, we built Fusebox 2.0 to work with the best of them. Additionally, since Fusebox 2.0 is multi-platform compatible, you can take it with you if you ever change platforms!<br>
                                <a target="_blank" href="https://support.fusebox.fm/article/417-platform-support">Read more...</a>
                            </p>
                        </div>
                    </div>
                </div><!-- .article -->

                <div class="article">
                    <h4>
                        <a href="#" @click.prevent="toggleArticle">Creating and customizing a player</a>
                    </h4>
                    <div class="expandable">
                        <div class="article-content">
                            <p>
                                Choosing the style and look of your podcast player can be just as important as the function and features. No one wants a player that doesn't fit your website's vibe! That's why it's important to customize your podcast player the way you want it. <br>
                                <a target="_blank" href="https://support.fusebox.fm/article/444-creating-and-customizing">Read more...</a>
                            </p>
                        </div>
                    </div>
                </div><!-- .article -->

                <div class="article">
                    <h4>
                        <a href="#" @click.prevent="toggleArticle">Managing your shows</a>
                    </h4>
                    <div class="expandable">
                        <div class="article-content">
                            <p>
                                Sometimes the playing with all the knobs and buttons is just as fun as using the product itself. The Show Info page is no different. Here, you can customize you brand color, podcast name, add your subscriber links, and more.<br>
                                <a target="_blank" href="https://support.fusebox.fm/article/433-manage-shows">Read more...</a>
                            </p>
                        </div>
                    </div>
                </div><!-- .article -->

                <div class="article">
                    <h4>
                        <a href="#" @click.prevent="toggleArticle">What is the difference between JavaScript and iFrame embed codes?</a>
                    </h4>
                    <div class="expandable">
                        <div class="article-content">
                            <p>
                                Understanding code languages may not be every podcaster's strong suit and that's okay. To help, we've summarized the important differences that matter most to you and scenarios where you may choose one over the other.<br>
                                <a target="_blank" href="https://support.fusebox.fm/article/451-javascript-vs-iframe">Read more...</a>
                            </p>
                        </div>
                    </div>
                </div><!-- .article -->

                <div class="article">
                    <h4>
                        <a href="#" @click.prevent="toggleArticle">Where can I find my RSS URL?</a>
                    </h4>
                    <div class="expandable">
                        <div class="article-content">
                            <p>
                                Finding your RSS URL is sometimes like trying to find your keys. You know they're important and you typically keep it in a safe place, but inevitably they go missing. For Fusebox 2.0, the RSS URL is the "key" to adding your shows.<br>
                                <a target="_blank" href="https://support.fusebox.fm/article/438-find-rss-url">Read more...</a>
                            </p>
                        </div>
                    </div>
                </div><!-- .article -->
            </div><!-- .articles -->

            <a href="https://support.fusebox.fm" target="_blank">See all articles →</a>
        </div><!-- .widget-body -->
    </div>
</template>

<script>
export default {
    /**
     * @returns {Array} Data.
     */
    data() {
        return {
            expandedArticle: null,
        };
    },

    methods: {
        /**
         * Toggles article.
         *
         * @param {object} e Event.
         * @returns {void}
         */
        toggleArticle(e) {
            if (this.expandedArticle) {
                this.collapseArticle(this.expandedArticle);
            }

            const article = e.target.closest('.article');

            if (! article.isSameNode(this.expandedArticle)) {
                this.expandArticle(article);
                this.expandedArticle = article;
            } else {
                this.expandedArticle = null;
            }
        },

        /**
         * Expand article.
         *
         * @param {HTMLElement} item Item to expand.
         * @returns {void}
         */
        expandArticle(item) {
            const expandable = item.querySelector('.expandable');

            if (expandable) {
                expandable.style.maxHeight = `${expandable.scrollHeight}px`;
            }

            item.classList.add('is-expanded');
        },

        /**
         * Collapse article.
         *
         * @param {HTMLElement} item Item to expand.
         * @returns {void}
         */
        collapseArticle(item) {
            const expandable = item.querySelector('.expandable');

            if (expandable) {
                expandable.style.maxHeight = 0;
            }

            item.classList.remove('is-expanded');
        },
    },
};
</script>
